/* Keep an explicitly selected theme preview throughout storefront navigation. */
(()=>{
 const current=new URL(location.href);
 const id=current.searchParams.get('preview_theme_id');
 if(!id||!/^\d+$/.test(id))return;
 function rewrite(anchor){
  const raw=anchor.getAttribute('href');
  if(!raw||raw.startsWith('#')||anchor.hasAttribute('download'))return;
  let url;try{url=new URL(raw,location.href)}catch{return}
  if(url.origin!==location.origin||!/^https?:$/.test(url.protocol))return;
  if(/^\/(?:admin|checkout|checkouts|account|apps)(?:\/|$)/.test(url.pathname))return;
  if(url.searchParams.has('preview_theme_id'))return;
  url.searchParams.set('preview_theme_id',id);
  anchor.setAttribute('href',url.pathname+url.search+url.hash);
 }
 function scan(root){if(root.matches?.('a[href]'))rewrite(root);root.querySelectorAll?.('a[href]').forEach(rewrite)}
 scan(document);
 document.addEventListener('click',event=>{const a=event.target.closest?.('a[href]');if(a)rewrite(a)},true);
 document.addEventListener('auxclick',event=>{const a=event.target.closest?.('a[href]');if(a)rewrite(a)},true);
 new MutationObserver(records=>{for(const r of records){if(r.type==='attributes')rewrite(r.target);else r.addedNodes.forEach(n=>{if(n.nodeType===1)scan(n)})}}).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['href']});
})();
